import { getToken, clearToken } from "./auth";

const BASE = import.meta.env.VITE_API_BASE ?? "";

export interface PromptTemplate {
  key: string;
  description: string;
  content: string;
  updatedAt: string;
  hasDefault: boolean;
}

async function authed(path: string, init?: RequestInit): Promise<Response> {
  const token = getToken();
  const headers: Record<string, string> = { ...(init?.headers as Record<string, string> | undefined) };
  if (token) headers.Authorization = `Bearer ${token}`;
  const res = await fetch(`${BASE}${path}`, { ...init, headers });
  if (res.status === 401) {
    clearToken();
    window.location.href = "/login";
    throw new Error("unauthorized");
  }
  return res;
}

async function getJson<T>(path: string): Promise<T> {
  const res = await authed(path);
  if (!res.ok) throw new Error(`request failed: ${res.status}`);
  return res.json();
}

async function send<T>(path: string, method: string, body?: unknown): Promise<T> {
  const res = await authed(path, {
    method,
    headers: body === undefined ? {} : { "Content-Type": "application/json" },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`request failed: ${res.status} ${text}`);
  }
  return res.json();
}

export const promptsApi = {
  list: () => getJson<{ prompts: PromptTemplate[] }>(`/api/prompts`),
  update: (key: string, patch: { content?: string; description?: string }) =>
    send<{ prompt: PromptTemplate }>(`/api/prompts/${encodeURIComponent(key)}`, "PATCH", patch),
  reset: (key: string) =>
    send<{ prompt: PromptTemplate }>(`/api/prompts/${encodeURIComponent(key)}/reset`, "POST"),
};
